<template>
  <div class="home">
    <div class="banner_wrap">
      <img :src="bannerUrl" alt="" />
    </div>
    <div class="section course_structure">
      <div class="course_structure_wrap w1200">
        <div class="title">课程体系</div>
        <ul class="cs_list cs_list_1">
          <li
            class="cs_item"
            v-for="(course, index) in courseList1"
            :key="index"
          >
            <div class="content">
              <div class="main_title">第{{ numberConfig[index + 1] }}讲</div>
              <div class="course_name">{{ course.name }}</div>
            </div>
          </li>
        </ul>
        <ul class="cs_list cs_list_2">
          <li
            class="cs_item"
            v-for="(course, index) in courseList2"
            :key="index"
          >
            <div class="content">
              <div class="main_title">第{{ numberConfig[index + 6] }}讲</div>
              <div class="course_name">{{ course.name }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 培训预告 -->
    <div class="section training_notice">
      <div class="title">培训预告</div>
      <ul class="tn_list w1200">
        <li
          class="tn_item"
          v-for="(course, index) in courseList"
          :key="index"
          @click="viewDetail(course)"
        >
          <div class="cover_wrap">
            <img :src="!mobile ? course.cover : course.mobileCover" alt="" />
          </div>
          <div class="course_info">
            <div class="course_name">{{ course.name }}</div>
            <div>
              <span class="school">{{ course.school }}</span>
              <span class="author">{{ course.author }}</span>
            </div>
            <div class="time">{{ course.time }}</div>
            <div class="mb">
              <div class="learn_btn">立即学习</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="footer">
      <div>京公网安备 11010802033069号</div>
      <div class="icp">京ICP备 10038239号-6</div>
      <div>技术支持：北京方正阿帕比技术有限公司</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { numberConfig, courseArr } from './home.js'
import { mapGetters } from 'vuex'
const path1 = require('@/assets/home_banner.jpg')
const path2 = require('@/assets/home_banner_mobile.jpg')
export default {
  name: 'Home',
  data () {
    return {
      numberConfig,
      courseList: courseArr
    }
  },
  computed: {
    ...mapGetters(['mobile']),
    courseList1 () {
      return this.courseList.filter((item, index) => {
        return index < 5
      })
    },
    courseList2 () {
      return this.courseList.filter((item, index) => {
        return index > 4
      })
    },
    bannerUrl () {
      return this.mobile ? path2 : path1
    }
  },
  methods: {
    viewDetail (course) {
      this.addBaiduTongjiEvent(course)

      if (this.mobile) {
        if (course.fileId) {
          this.$router.push({
            path: `/play/${course.id}`
          })
        } else if (course.path) {
          window.open(course.path)
        } else {
          this.$message({
            type: 'warning',
            message: '培训未开始'
          })
        }
      } else {
        this.openPage({
          path: `/course_detail/${course.id}`
        })
      }
    },
    addBaiduTongjiEvent (course) {
      window._hmt &&
        window._hmt.push([
          '_trackCustomEvent',
          '浏览课程',
          {
            name: course.name
          }
        ])
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/mixin.scss";
$fontColor: #3939d8;
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.home {
  .banner_wrap {
    img {
      width: 100%;
      min-width: 1200px;
      vertical-align: middle;
    }
  }
  .section {
    .title {
      color: $fontColor;
      font-size: 48px;
      line-height: 150px;
      text-align: center;
      font-weight: bold;
    }
    &.course_structure {
      background-color: #fff;
      .cs_list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .cs_item {
          width: 208px;
          height: 240px;
          margin-right: 7px;
          background-image: url("~@/assets/button_bg.png");
          background-repeat: no-repeat;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .content {
            width: 166px;
            height: 144px;
            .main_title {
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 28px;
              text-align: center;
            }
            .course_name {
              font-size: 18px;
            }
          }
          &:hover {
            color: $fontColor;
            background-image: url("~@/assets/button_bg_active.png");
          }
        }
        &.cs_list_2 {
          position: relative;
          top: -52px;
        }
      }
    }
    &.training_notice {
      background-color: #e2edf3;
      .tn_list {
        display: flex;
        flex-wrap: wrap;
        .tn_item {
          box-sizing: border-box;
          border-radius: 4px;
          width: 360px;
          height: 360px;
          background-color: #fff;
          padding: 10px;
          margin-right: 60px;
          margin-bottom: 32px;
          cursor: pointer;
          box-shadow: 2px 2px 4px #eee;
          &:hover {
            .course_info {
              .course_name {
                color: $fontColor;
              }
            }
          }
          &:nth-child(3n) {
            margin-right: 0;
          }
          .cover_wrap {
            width: 340px;
            height: 200px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .course_info {
            line-height: 26px;
            .course_name {
              margin-top: 20px;
              font-size: 18px;
              color: #000;
              height: 60px;
              line-height: 30px;
              font-weight: bold;
              @include mult_dot(2);
            }
            .school {
              margin-right: 8px;
            }
            .author {
            }
            .time {
            }
          }
        }
      }
    }
  }
  .footer {
    text-align: center;
    line-height: 80px;
    background-color: #e2edf3;
    display: flex;
    justify-content: center;
    .icp {
      margin: 0 20px;
    }
  }
}
.mobile {
  .home {
    .banner_wrap {
      img {
        width: 100%;
        min-width: 100%;
        vertical-align: middle;
      }
    }
    .section {
      .title {
        font-size: 18px;
        line-height: px2rem(112);
        padding-left: px2rem(32);
        text-align: left;
      }
      &.course_structure {
        display: none;
      }
      &.training_notice {
        .tn_list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .tn_item {
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            border-radius: 0;
            width: 100%;
            height: auto;
            background-color: #fff;
            margin-right: 0;
            margin-bottom: px2rem(32);
            cursor: pointer;
            box-shadow: 2px 2px 4px #eee;
            padding: px2rem(16) px2rem(12);
            &:hover {
              color: $fontColor;
              .course_info {
                .course_name {
                  color: $fontColor;
                }
              }
            }

            .cover_wrap {
              width: px2rem(340);
              height: px2rem(200);
              img {
                width: 100%;
                height: 100%;
              }
            }
            .course_info {
              width: 50%;
              line-height: 14px;
              font-size: 12px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .course_name {
                margin-top: 0;
                font-size: 12px;
                height: 32px;
                line-height: 16px;
                @include mult_dot(2);
              }
              .school {
              }
              .author {
              }
              .time {
              }
              .mb {
                .learn_btn {
                  display: inline-block;
                  color: #fff;
                  background-color: #ff9a27;
                  padding: px2rem(10) px2rem(44);
                  border-radius: 30px;
                }
              }
            }
          }
        }
      }
    }
    .footer {
      line-height: 1.7;
      display: block;
    }
  }
}
</style>
